import type { NodeApi } from "@hogartrabe/react-arborist-vrh";

export const copyNode = (
  node: NodeApi,
  setCopiedItem: (node: NodeApi) => void,
) => {
  setCopiedItem(node);
  return null;
};
